var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BreadcrumbList',{attrs:{"items":[]}}),_c('FlexibleContentArea',[_c('PageMain',[_c('div',{staticClass:"error-title"},[_vm._v(" "+_vm._s(_vm.$t("message.AccessErrorPage.error_title"))+" ")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }